import "./OurValues.scss";

const ItemInfo = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <div className="item-info">
      <h4>{title}</h4>
      <p>{description}</p>
    </div>
  );
};

const OurValues = () => {
  const items = [
    {
      title: "UN TRANSPORT LIMITÉ",
      description:
        "Nous favorisons des fournisseurs français et européens afin de limiter notre empreinte carbone liée au transport. Dans un souhait de cohérence nous avons également choisi notre partenaire de le transport car il est titulaire de la certification ISO 14001.",
    },
    {
      title: "DES PRODUITS PROPRES",
      description:
        "Depuis sa création, SP Hygiène s'engage à commercialiser des produits sélectionnés afin de garantir qualité, sécurité et responsabilité écologique. Nous plaçons les personnes et l'environnement au coeur de notre démarche.",
    },
    {
      title: "DES EMBALLAGES RÉDUITS",
      description:
        "Afin de limiter les déchets liés au conditionnement, nous proposons des emballages groupes en cartons recyclés et recyclables qui, récupérés, sont déposés dans un Etablissement social d'Aide par le travail.",
    },
    {
      title: "UN CHOIX DE FOURNISSEURS ENGAGÉS",
      description:
        "Au-delà de produits de qualité, SP Hygiène souhaite proposer à ses clients des produits respectant leurs valeurs. Cela passe par un choix de ses partenaires. La majorité de nos fournisseurs sont investis dans des programmes de protection de l'environnement.",
    },
  ];

  return (
    <div className="our-values">
      {items.map((item, idx) => (
        <ItemInfo key={`${idx}-item`} {...item} />
      ))}
    </div>
  );
};

export default OurValues;
